import { computed, ref } from 'vue'
import { mean, zipObj } from 'ramda'
import { distinct, nonNull } from './fns'
import { categories, codes, groups, testCase } from '../app/execute/execute-state'

export const initialFinishedTestCaseOrder = () => ({
  codes: [],
  categories: [],
  groups: [],
})

export const finishedTestCaseOrder = ref()

export const addFinishedTestCase = () => {
  const { code, category, groups } = testCase.value
  if (finishedTestCaseOrder.value && !finishedTestCaseOrder.value.codes.includes(code)) {
    finishedTestCaseOrder.value.codes.push(code)
    finishedTestCaseOrder.value.categories.push(category)
    finishedTestCaseOrder.value.groups.push(...groups)
  }
}

const calculateOrder = (keys, finishedData) => {
  const data = finishedData
    .map((value, index) => ({ value, index }))
  return zipObj(
    keys,
    keys
      .map(value => {
        const indexes = data
          .filter(({ value: other }) => value === other)
          .map(({ index }) => index)
        if (!indexes.length) {
          return null
        }
        return mean(indexes) / Math.max(1, data.length - 1)
      })
  )
}

const currentCodesOrder = computed(() =>
  calculateOrder(codes.value, finishedTestCaseOrder.value.codes)
)

const currentCategoriesOrder = computed(() =>
  calculateOrder(categories.value, finishedTestCaseOrder.value.categories)
)

const currentGroupsOrder = computed(() =>
  calculateOrder(groups.value, finishedTestCaseOrder.value.groups)
)

export const getTestCaseOrder = ({ code, category, groups }) => {
  const groupOrders = groups
    ?.map(group => combinedTestCaseOrder.value.groups[group])
    .filter(nonNull)
  return {
    code: combinedTestCaseOrder.value.codes[code],
    category: combinedTestCaseOrder.value.categories[category],
    group: groupOrders?.length ? mean(groupOrders) : null,
  }
}

export const initialHistoricalTestCaseOrder = () => ({
  codes: {},
  categories: {},
  groups: {},
})

export const historicalTestCaseOrder = ref()

export const combinedTestCaseOrder = computed(() => ({
  codes: combineOrder(currentCodesOrder.value, historicalTestCaseOrder.value.codes),
  categories: combineOrder(currentCategoriesOrder.value, historicalTestCaseOrder.value.categories),
  groups: combineOrder(currentGroupsOrder.value, historicalTestCaseOrder.value.groups),
}))

const combineOrder = (a, b) => {
  const keys = [...Object.keys(a), ...Object.keys(b)].filter(distinct)
  return zipObj(
    keys,
    keys
      .map(key =>
        a[key] != null && b[key] != null
          ? mean([a[key], b[key]])
          : a[key] ?? b[key])
  )
}
